import { featureRequestsValidator } from "@/validators";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

export const Route = createFileRoute("/admin/feature-requests/")({
  validateSearch: zodValidator(featureRequestsValidator),
  loaderDeps: (search) => search,
});
